import axios from "axios";

const getSubCategoriesApi = async (id, page) => {
  const res = await axios.get(`/v1/website/category-products/${id}?page=${page}`);
  return res.data;
};

export { getSubCategoriesApi };
